import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getAllTemplateMaster } from "../services/svt/svt-user";

const useGetAllTemplateMasterData = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const { i18n } = useTranslation();
    const currentLanguage = i18n.language;
    const languageMap = {
        en: 1,
        ch: 19,
        jp: 2
    };
    const languageId = languageMap[currentLanguage];

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const result = await getAllTemplateMaster(languageId);
                setData( result);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [i18n.language]); // Refetch when language changes

    if (data) {
        // Filter data.data by languageId before processing
        const filteredData = Array.isArray(data.data)
            ? data.data.filter(item => item.languageId === languageId)
            : [];
         const templatesData = Array.from(
            new Set(filteredData.map((item) => item.templateMasterId))
        )
            .map((id) => {
                return filteredData.find((item) => item.templateMasterId === id);
            })
            .map(
                ({
                    assessmentId,
                    imageUri,
                    templateMasterId,
                    templateMasterName,
                }) => ({
                    assessmentId,
                    imageUri,
                    templateMasterId,
                    templateMasterName,
                })
            );

        const levelsData = Array.from(
            new Set(filteredData.map((item) => item.levelId))
        )
            .map((id) => {
                return filteredData.find((item) => item.levelId === id);
            })
            .map(({ levelId, levelName }) => ({
                levelId,
                levelName,
            }));

        return [templatesData, levelsData, loading];
    }

    return [null, null];
};

export default useGetAllTemplateMasterData;
